import { render, staticRenderFns } from "./MenuUser.vue?vue&type=template&id=6c5d90d4&scoped=true"
import script from "./MenuUser.vue?vue&type=script&lang=js"
export * from "./MenuUser.vue?vue&type=script&lang=js"
import style0 from "./MenuUser.vue?vue&type=style&index=0&id=6c5d90d4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c5d90d4",
  null
  
)

export default component.exports